import styled from 'styled-components';
import { Modal } from 'react-bootstrap';

export const Container = styled(Modal.Body)`
  background-color: #ffffff;
  border-radius: 8px;
  width: 100%;
  height: auto;
  padding: 30px;
  overflow-x: hidden;
`;

export const TextTimer = styled.p`
  text-align: center;
  margin: 0;

  a {
    color: #0000ff;
    &:hover {
      text-decoration: underline;
    }
  }
`;

export const ContentButtons = styled.div`
  display: flex;
  justify-content: space-around;
  flex-direction: column;
  gap: 15px;

  button {
    width: 100%;
  }
`;

export const Header = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
`;

export const CloseIcon = styled.span`
  font-size: 1.25rem;
  margin-top: -50px;
  margin-right: -15px;
  color: #074f8c;
  cursor: pointer;

  @media (max-width: 370px) {
    font-size: 1.125rem;
  }
`;

export const Left = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-bottom: 10px;
  align-items: flex-start;
`;

export const Title = styled.span`
  font-size: 26px;
  color: #0b29fb;
  @media (max-width: 375px) {
    font-size: 23px;
  }
`;

export const Content = styled.form`
  width: 100%;
  height: auto;
  display: flex;
  flex-direction: column;
  gap: 22px;
`;

export const SubTitle = styled.span``;
